<script setup lang="ts">
import type { TheoryContent } from 'types/course/step';
import { computed, ref } from 'vue';
import VimeoVideoCard from 'shared/components/VimeoVideoCard/VimeoVideoCard.vue';
import { mdiFullscreen, mdiFullscreenExit } from '@quasar/extras/mdi-v7';
import { prepareCmsHtml } from '../../../utilities/cmsHtmlSanitizer';

interface Props {
  content: TheoryContent;
}

const props = defineProps<Props>();
const slide = ref(1),
  fullscreen = ref(false);
const contentType = computed(() =>
  props.content?.__component?.split('.')?.pop(),
);

const sanitizedHtml = computed(() => prepareCmsHtml(props.content?.html));

const imageUrl = computed(() => {
  return props.content?.image?.url ? props.content.image.url : '';
});
// defineEmits<{
//   // 'update:modelValue': [payload: string]
// }>()
</script>

<template>
  <!-- eslint-disable vue/no-v-text-v-html-on-component -->
  <!-- eslint-disable vue/no-v-html -->
  <q-card
    square
    flat
    class="q-ma-none"
  >
    <q-card-section
      v-if="contentType === 'html-content'"
      class="q-pa-none"
      v-html="sanitizedHtml"
    >
    </q-card-section>
    <q-card-section
      v-else-if="contentType === 'image-content'"
      class="q-pa-none"
    >
      <p>{{ content?.intro }}</p>

      <q-carousel
        v-model="slide"
        v-model:fullscreen="fullscreen"
        animated
        height="auto"
        infinite
      >
        <q-carousel-slide
          :name="1"
          class="q-pa-none"
        >
          <q-img
            :src="imageUrl"
            :ratio="4 / 3"
            :height="
              fullscreen ? '100vh' : $q.platform.is.mobile ? '40vh' : '64vh'
            "
            :fit="fullscreen ? 'contain' : 'scale-down'"
          ></q-img>
        </q-carousel-slide>

        <template #control>
          <q-carousel-control
            position="bottom"
            class="row justify-center"
            :offset="[0, 30]"
          >
            <q-btn
              push
              round
              dense
              style="opacity: 0.8"
              color="white"
              text-color="primary"
              :icon="fullscreen ? mdiFullscreenExit : mdiFullscreen"
              @click="fullscreen = !fullscreen"
            />
          </q-carousel-control>
        </template>
      </q-carousel>

      <p>{{ content?.outro }}</p>
    </q-card-section>
    <q-card-section
      v-else-if="contentType === 'video-embed-content'"
      class="q-pa-none"
    >
      <VimeoVideoCard
        v-if="content?.video_embed?.provider === 'vimeo'"
        flat
        square
        :vimeo-id="+content?.video_embed?.providerUid"
        class="q-pa-none row justify-center"
      >
      </VimeoVideoCard>
    </q-card-section>
  </q-card>
</template>
